import { render } from "./vue-core-image-upload.vue?vue&type=template&id=061d072a"
import script from "./vue-core-image-upload.vue?vue&type=script&lang=js"
export * from "./vue-core-image-upload.vue?vue&type=script&lang=js"

import "./style/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__